// extracted by mini-css-extract-plugin
export var aboutPage = "About-module--aboutPage--Z-wVA";
export var aboutPara = "About-module--aboutPara--QXuAZ";